import React from 'react';
import greenCross from '@assets/img/icones/btnClose.svg';
import redCross from '@assets/img/icones/btnCloseRed.svg';
//import blueBtnClose from '@image/icones/blueBtnClose.svg'
import warning from '@assets/img/icones/warning.svg';
import infoSuccess from '@assets/img/icones/succes.svg';
import { ERROR, SUCCESS, NUMBER_CHARACTER } from '@utils/constants';
export default class StandardNotification extends React.Component {
  render() {
    let { type, message, withBorder } = this.props;
    let contentClass = '',
      borderRight = '',
      imgCrois = greenCross,
      classMessage = '';
    if (type === ERROR) {
      contentClass = 'content-standard-notification-error ';
      borderRight = 'border-right-error ';
      imgCrois = redCross;
    }
    // else if (type === REJECTED_CANDIDATE) {
    //   contentClass = "content-standard-notification-info "
    //   borderRight = "border-right-info "
    //   imgCrois = blueBtnClose
    // }
    else if (type === SUCCESS) {
      contentClass = 'content-standard-notification-success ';
      borderRight = 'border-right-success ';
      imgCrois = greenCross;
    }

    if (message?.length <= NUMBER_CHARACTER) {
      classMessage = 'custom-message-normale';
    } else {
      classMessage = 'custom-message-too-long';
    }
    return (
      <div className={`${contentClass} d-flex`}>
        {withBorder ? <div className={borderRight}></div> : ''}

        <div className="content-notification d-flex">
          <div>
            {type ? (
              <div className="info-img">
                <img
                  src={type === ERROR ? warning : infoSuccess}
                  alt="icon-Info"
                />
              </div>
            ) : (
              ''
            )}
          </div>
          <div className="d-flex flex-justify-end content-message">
            <div className="d-flex flex-justify-between content-between">
              <span className={`medium ${classMessage}`}>{message}</span>
              <div className="info-img">
                <div className="info-img">
                  <img src={imgCrois} alt="icon-Info" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
